import { Quote } from "lucide-react";

interface FoundersPledgeProps {
  variant: "men" | "women";
}

const FoundersPledge = ({ variant }: FoundersPledgeProps) => {
  const isDark = variant === "women";

  return (
    <section className={`py-20 md:py-32 ${isDark ? "bg-navy" : "bg-cream"}`}>
      <div className="container mx-auto px-6">
        <div className={`max-w-3xl mx-auto rounded-2xl p-8 md:p-12 ${
          isDark 
            ? "bg-navy-light border border-cream/10" 
            : "bg-cream-dark border border-navy/10"
        }`}>
          {/* Quote Icon */}
          <div className="flex justify-center mb-8">
            <div className="w-14 h-14 rounded-full bg-gold/20 flex items-center justify-center">
              <Quote className="w-7 h-7 text-gold" />
            </div>
          </div>

          {/* Pledge Content */}
          <div className="text-center space-y-6">
            <h2 className={`font-serif text-2xl md:text-3xl font-bold ${isDark ? "text-cream" : "text-navy"}`}>
              ההתחייבות שלי אליך
            </h2>

            <div className={`space-y-4 text-lg leading-relaxed ${isDark ? "text-cream/80" : "text-muted-foreground"}`}>
              <p>
                אני לא יכול להבטיח לכם אהבה, כי זה תלוי בכימיה שלכם.
              </p>
              <p>
                אבל אני <span className="text-gold font-semibold">כן מתחייב לסטנדרט של שקט נפשי:</span>
              </p>
              <p className={`font-medium ${isDark ? "text-cream" : "text-navy"}`}>
                ✅ כל פרופיל במאגר עובר אימות זהות אישי.
                <br />
                ✅ כל מועמד עובר תהליך איפיון עומק.
                <br />
                ✅ כל התאמה נבדקת על ידי מאמן לפני שהיא מגיעה אליך.
              </p>
              <p>
                המחויבות שלי היא לתהליך מקצועי, כנה ובטוח.
                <br />
                השאר — בידיים שלכם.
              </p>
            </div>

            {/* Signature */}
            <div className="pt-8 border-t border-gold/20 mt-8">
              <p 
                className={`text-2xl md:text-3xl font-semibold ${isDark ? "text-cream" : "text-navy"}`}
              >
                שאול שגב
              </p>
              <p className={`text-sm mt-2 ${isDark ? "text-cream/50" : "text-muted-foreground"}`}>
                מייסד "אמון בזוגיות"
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FoundersPledge;
